import React from 'react';
import CircularPackageSlider from '../components/CircularPackageSlider';
import { domesticPackages } from '../mock';
import { MapPin, Calendar, Phone } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Link } from 'react-router-dom';

const DomesticPackages = () => {
  const backpackingTrips = domesticPackages.filter(pkg => pkg.type === 'backpacking');
  const standardTrips = domesticPackages.filter(pkg => pkg.type === 'standard');

  return (
    <div className="min-h-screen pt-32 pb-20">
      {/* Hero Section */}
      <section className="relative h-96 mb-20 overflow-hidden">
        <img 
          src="https://images.unsplash.com/photo-1524492412937-b28074a5d7da?w=1200" 
          alt="Domestic Travel"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-red-900/80 to-blue-900/80"></div>
        <div className="relative z-10 container mx-auto px-4 h-full flex items-center justify-center text-center text-white">
          <div>
            <h1 className="text-5xl md:text-6xl font-bold mb-6">
              Explore Incredible India
            </h1>
            <p className="text-xl md:text-2xl max-w-3xl mx-auto">
              From the Himalayas to the beaches, discover the diverse beauty of our homeland
            </p>
          </div>
        </div>
      </section>

      {/* Special Backpacking Section */}
      <section className="container mx-auto px-4 mb-20">
        <div className="bg-gradient-to-br from-red-50 to-blue-50 rounded-3xl p-8 md:p-12">
          <div className="text-center mb-12">
            <div className="inline-block bg-red-600 text-white px-6 py-2 rounded-full text-sm font-semibold mb-4">
              🔥 SPECIAL WEEKEND TRIPS
            </div>
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Backpacking Adventures
            </h2>
            <p className="text-xl text-gray-600">
              Join our <span className="text-red-600 font-semibold">Spiti Valley & Leh Ladakh</span> trips departing every Saturday!
            </p>
          </div>

          <CircularPackageSlider packages={backpackingTrips} />

          <div className="mt-12 bg-white rounded-2xl p-6 md:p-8 shadow-lg">
            <div className="grid md:grid-cols-3 gap-6 text-center">
              <div>
                <Calendar size={40} className="text-red-600 mx-auto mb-3" />
                <h3 className="font-bold text-lg mb-2">Every Saturday</h3>
                <p className="text-gray-600 text-sm">Regular departures from Delhi</p>
              </div>
              <div>
                <MapPin size={40} className="text-blue-600 mx-auto mb-3" />
                <h3 className="font-bold text-lg mb-2">Scenic Routes</h3>
                <p className="text-gray-600 text-sm">Carefully planned itineraries</p>
              </div>
              <div>
                <Phone size={40} className="text-green-600 mx-auto mb-3" />
                <h3 className="font-bold text-lg mb-2">24/7 Support</h3>
                <p className="text-gray-600 text-sm">We're always here for you</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Other Domestic Packages */}
      <section className="container mx-auto px-4 mb-20">
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            More Destinations to Explore
          </h2>
          <p className="text-xl text-gray-600">
            Curated tour packages across India
          </p>
        </div>

        <CircularPackageSlider packages={standardTrips} />
      </section>

      {/* Why Choose Us */}
      <section className="container mx-auto px-4">
        <div className="bg-gradient-to-r from-red-600 to-blue-600 rounded-3xl p-8 md:p-12 text-white text-center">
          <h2 className="text-4xl font-bold mb-6">Why Travel with TUM Holidays?</h2>
          <div className="grid md:grid-cols-4 gap-6 mt-8">
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <div className="text-4xl font-bold mb-2">500+</div>
              <div className="text-sm">Happy Travelers</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <div className="text-4xl font-bold mb-2">50+</div>
              <div className="text-sm">Destinations</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <div className="text-4xl font-bold mb-2">100%</div>
              <div className="text-sm">Satisfaction</div>
            </div>
            <div className="bg-white/10 backdrop-blur-sm rounded-xl p-6">
              <div className="text-4xl font-bold mb-2">24/7</div>
              <div className="text-sm">Support</div>
            </div>
          </div>
          <Button 
            asChild
            size="lg"
            className="mt-8 bg-white text-red-600 hover:bg-gray-100 text-lg px-8 py-6 transition-all duration-300 hover:scale-105"
          >
            <Link to="/contact">Start Your Journey Today</Link>
          </Button>
        </div>
      </section>
    </div>
  );
};

export default DomesticPackages;